import $ from 'jquery';
import Backbone from 'backbone';


export default Backbone.Collection.extend({
  parse: function (response) {
    return response.results;
  },
});



// WEBPACK FOOTER //
// ./static/js/collections/coachhub.js